// ============================================
// Google Maps Reklam Verme - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleMapsReklamVermeContent: BlogContent = {
  tableOfContents: [
    { id: "maps-ads", title: "Google Maps Ads" },
    { id: "kampanya-stratejisi", title: "Kampanya Stratejisi" },
    { id: "hedefleme", title: "Hedefleme" },
    { id: "roi-optimizasyonu", title: "ROI Optimizasyonu" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google Maps reklam verme</strong> kampanya stratejileri ve ROI optimizasyonu."
    }
  ]
};

export default googleMapsReklamVermeContent;
